export default __webpack_public_path__ + "static/media/moreOption.50a9ba89.svg";